import { forwardRef } from 'react';
import classNames from 'classnames';
import {Card, Col, Row} from 'react-bootstrap';
import ArrowButton from '../../../common/button-arrow';

// forwardRef so react-sortable-hoc (vendored, React-19) can capture this row's
// DOM node via a ref instead of the removed findDOMNode.
const ProductItem = forwardRef(({
  item, status, image, categoryName, deleteDisabled, editDisabled, itemType, ...props
}, ref) => {
  const statusClass = classNames('product-status', (status ? status.toLowerCase() : ''));

  return (
    <Card ref={ref} className="product-item">
      <Card.Body>
        <Row>
          <Col md={8} style={{userSelect: 'none'}}>
            {image && <img className="imgPreview" src={image}/>}
            {(status === 'INACTIVE' || status === 'DRAFT') && (
              <span className={statusClass}>
                {status}
              </span>
            )}
            {item.name || item.attributes.name}
            {
              categoryName && (
                <span className="category-name">
                  Category:
                  <span>
                    {categoryName}
                  </span>
                </span>
              )
            }
            {
              categoryName && status === 'INACTIVE' && (
                <span className={statusClass}>
                  {status}
                </span>
              )
            }
          </Col>
          <Col md={4}>
            <ArrowButton
              arrow={false}
              className="float-end"
              disabled={!!deleteDisabled}
              onClick={() => props.onDelete(item.id)}
              permissions={{
                action: 'destroy',
                subjectClass: itemType
              }}
              submit={false}
            >
              Delete
            </ArrowButton>
            <ArrowButton
              arrow={false}
              className="float-end"
              color="grey"
              disabled={!!editDisabled}
              onClick={() => props.onEdit(item.id)}
              permissions={{
                action: 'update',
                subjectClass: itemType
              }}
              submit={false}
            >
              Edit
            </ArrowButton>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
});

ProductItem.displayName = 'ProductItem';

export default ProductItem;
